/* eslint new-cap: "off", no-param-reassign: "off" */
/* globals GlobalE, gle, jQuery */
'use strict';

/**
 * Sets a new cookie
 *
 * @param {string} cname is passed to a new cookie object.
 * @param {string} cvalue is passed to a new cookie object.
 * @param {number} exdays is passed to a new cookie object method setMaxAge.
 */
function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = 'expires = ' + d.toUTCString();
    document.cookie = cname + ' = ' + cvalue + '; ' + expires + '; path=/';
}

window.countrySwitcherDataLoaded = (('countrySwitcherDataLoaded' in window) ? window.countrySwitcherDataLoaded : false);
if (window.countrySwitcherDataLoaded === false && (typeof window.scriptLoaderData !== 'undefined') && (window.gle)) {
    if ((document.cookie.indexOf('GlobalE_Init') === -1) && window.scriptLoaderData.country !== 'US') {
        setCookie('GlobalE_Init', true, 30);
    }
    gle('LoadShippingSwitcher', window.scriptLoaderData.country, window.scriptLoaderData.culture, window.scriptLoaderData.currency, false, function () {
        var links = document.getElementsByClassName('globale-selector');
        Array.prototype.map.call(links, function (link) {
            GlobalE.AttachEvent('click', link, function () {
                return gle('ShippingSwitcher', 'show');
            });
        });
    });
    gle('OnShippingSwitcherClosed', function (e) {
        jQuery(document).trigger('GlobalE:switcherClose');

        if (
            (e.button === 'save')
            && (
                (e.country !== window.scriptLoaderData.country)
                || (e.currency !== window.scriptLoaderData.currency)
            )
        ) {
            if (e.isOperatedByGlobale || !e.isRedirect) {
                GlobalE.UpdateCustomerInfo(e.country, e.currency, false);
            }
            var localeSwitcher = $('.js-locale-toggler');
            var queryString = $('.page').data('querystring');
            var action = $('.page').data('action');
            var url = localeSwitcher.attr('href');
            var localeCode = localeSwitcher.data('locale');
            var localeCurrencyCode = localeSwitcher.data('currencycode');
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                data: {
                    code: localeCode,
                    queryString: queryString,
                    CurrencyCode: localeCurrencyCode,
                    GlobalECountryCode: e.country,
                    action: action
                },
                success: function (response) {
                    if (response && response.redirectUrl) {
                        window.location.href = response.redirectUrl;
                    }
                }
            });
            if (!e.isRedirect) {
                window.location.reload();
            } else if (window.scriptLoaderData.performFrontendSiteUrlRedirect) {
                jQuery.ajax(window.scriptLoaderData.getSiteRedirectUrl, {
                    dataType: 'json',
                    data: {
                        countryCode: e.country,
                        currencyCode: e.currency
                    },
                    success: function (resp) {
                        if (!resp.success) {
                            window.location.reload();
                        } else if (resp.redirectUrl) {
                            window.location.href = resp.redirectUrl;
                        }
                    }
                });
            }
        } else {
            window.currentForminContext.val('US').trigger('change');
        }
        return false;
    });
    window.countrySwitcherDataLoaded = true;
}
